import {
  Box,
  Checkbox,
  Flex,
  SimpleGrid,
  Text,
  useColorModeValue
} from "@chakra-ui/react";

function RenderedVideos({ renderedData = [], selectedRenderVideos, onSelectedRenderedVideos }) {

  const outputVideoBorder = useColorModeValue('#40225f', '#fe72ff');

  return (
    <Box width="700px" display={'flex'} flexDirection={'column'} gap={6}>
      <Flex direction={'column'} gap={2}>
        <Flex alignItems={'center'} gap={2}>
          <Text fontWeight={'bold'}>Rendered Videos</Text>
        </Flex>
      </Flex>

      <Box maxH="460px" overflowY="auto" p={2}>
        <SimpleGrid columns={[1, 2, 3]} spacing={4}>
          {renderedData?.map((preview, index) => {
            const isErrored = preview?.success === false || preview?.error?.length > 0;

            return (
              <Box key={preview.media_job || index}>
                <Box
                  role="group"
                  overflow="hidden"
                  position="relative"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  py={2}
                  borderRadius="12px"
                  border={'2px solid transparent'}
                  bg={isErrored ? "gray.50" : "transparent"}
                  _hover={{ shadow: "md", cursor: isErrored ? "default" : "pointer", border: isErrored ? "2px solid gray" : `2px solid ${outputVideoBorder}` }}
                >
                  {isErrored ? (
                    <Box
                      width="200px"
                      height="300px"
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'center'}
                      flexDirection={'column'}
                      gap={2}
                    >
                      <Text fontSize="sm" color="gray.800" textAlign="center">
                        {preview?.error?.[0]
                          ? `${preview.error[0]} — Click back and render again.`
                          : "Video is still rendering..."}
                      </Text>
                    </Box>
                  ) : (
                    <>
                      <Box
                        as="video"
                        controls
                        src={preview.video_output}
                        width="200px"
                        height="300px"
                        borderRadius="12px"
                        objectFit="contain"
                        bg="gray.50"
                      />
                      <Checkbox
                        position="absolute"
                        top="14px"
                        left="14px"
                        bg="#fff"
                        isChecked={selectedRenderVideos.includes(preview)}
                        onChange={() => onSelectedRenderedVideos(preview)}
                        colorScheme='brand'
                        border="1px"
                        borderColor="gray.50"
                      />
                    </>
                  )}
                </Box>

                <Box mt={2} ml={1}>
                  <Text fontSize="xs" fontWeight="bold">
                    {preview?.name}
                  </Text>
                </Box>
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default RenderedVideos;
